var _rect, _path, _path2, _g, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_392_158919)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1C359F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9166 19.9724C39.9166 31.0119 30.9838 39.9447 19.9443 39.9447C8.93279 39.9447 0 31.0119 0 19.9724C0 8.93279 8.93279 0 19.9443 0C30.9838 0 39.9166 8.93279 39.9166 19.9724Z",
    fill: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_392_158919",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 38,
    height: 38
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3804 20.0105C38.3804 30.1849 30.1302 38.4323 19.9558 38.4323C9.78144 38.4323 1.53125 30.1849 1.53125 20.0105C1.53125 9.83331 9.78144 1.58594 19.9558 1.58594C30.1302 1.58594 38.3804 9.83331 38.3804 20.0105Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_392_158919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0678 29.5231H26.995C29.776 27.7253 31.6018 24.6073 31.6018 21.0398C31.6018 15.4779 27.0793 10.9834 21.5174 10.9834C15.9554 10.9834 11.4609 15.4779 11.4609 21.0398C11.4609 24.6073 13.2868 27.7253 16.0678 29.5231Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.02344 23.5684H40.8989V41.0688H-2.02344V23.5684Z",
    fill: "#6D7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9949 27.9226C31.9949 28.4844 31.5736 28.9058 31.0118 28.9058H9.43825C8.90453 28.9058 8.45508 28.4844 8.45508 27.9226C8.45508 27.3889 8.90453 26.9395 9.43825 26.9395H31.0118C31.5736 26.9395 31.9949 27.3889 31.9949 27.9226Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7748 28.9052H25.6739C28.4549 27.1074 30.3089 23.9894 30.3089 20.45C30.3089 14.888 25.7863 10.3936 20.2244 10.3936C14.6624 10.3936 10.168 14.888 10.168 20.45C10.168 23.9894 11.9939 27.1074 14.7748 28.9052Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.288 20.4506C28.288 24.8889 24.6643 28.5126 20.226 28.5126C15.7877 28.5126 12.1641 24.8889 12.1641 20.4506C12.1641 16.0123 15.7877 12.3887 20.226 12.3887C24.6643 12.3887 28.288 16.0123 28.288 20.4506ZM13.7933 20.4506C13.7933 24.0181 16.6866 26.9115 20.226 26.9115C23.7935 26.9115 26.6869 24.0181 26.6869 20.4506C26.6869 16.9112 23.7935 14.0179 20.226 14.0179C16.6866 14.0179 13.7933 16.9112 13.7933 20.4506Z",
    fill: "#B4B4B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04554 9.77594C9.49499 10.3939 10.0568 10.8996 10.5063 11.4895C10.7029 11.7704 11.04 11.9108 11.3771 11.7423C11.658 11.5737 11.7984 11.1243 11.6018 10.8434C11.1523 10.2535 10.5905 9.74785 10.1411 9.12986C9.94445 8.84895 9.60735 8.70851 9.27026 8.90514C8.98936 9.07368 8.82082 9.49503 9.04554 9.77594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0225 13.5685C7.72476 13.8494 8.45513 13.9898 9.15739 14.2707C9.46639 14.4112 9.83156 14.355 10.0282 14.0179C10.1686 13.737 10.0844 13.2875 9.77537 13.1471C9.07311 12.8662 8.34276 12.7257 7.6405 12.4448C7.3315 12.3044 6.93824 12.3606 6.7697 12.6977C6.60115 12.9786 6.71351 13.428 7.0225 13.5685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6127 7.50034C12.7251 8.25878 13.006 8.96104 13.1464 9.69139C13.2026 10.0285 13.4554 10.3094 13.8206 10.2813C14.1577 10.2532 14.4948 9.94421 14.4105 9.60713C14.2981 8.84868 14.0172 8.14641 13.8768 7.41606C13.8206 7.07897 13.5678 6.79807 13.2026 6.82616C12.8655 6.85425 12.5284 7.16325 12.6127 7.50034Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4066 19.0883L22.1663 20.0034H17.752L17.989 19.0883H22.4066ZM20.1122 24.1577L17.8606 21.4782L17.8639 20.6552H18.9765C19.2245 20.6552 19.4319 20.6091 19.5987 20.5169C19.7655 20.4248 19.8906 20.2997 19.974 20.1417C20.0574 19.9837 20.1001 19.8037 20.1023 19.6018C20.1001 19.299 20.0113 19.0521 19.8357 18.8611C19.6623 18.668 19.3759 18.5715 18.9765 18.5715H17.752L18.0219 17.416H18.9765C19.5361 17.416 20.0025 17.5005 20.3756 17.6695C20.7508 17.8363 21.0317 18.0744 21.2183 18.3838C21.407 18.6933 21.5025 19.0619 21.5047 19.4899C21.5025 19.8695 21.4388 20.2009 21.3137 20.484C21.1908 20.7671 20.9966 21.003 20.7311 21.1918C20.4677 21.3805 20.1243 21.521 19.7007 21.6131L19.6481 21.6329L21.6627 24.0985V24.1577H20.1122ZM22.4132 17.416L22.1663 18.3443H18.5321L18.779 17.416H22.4132Z",
    fill: "#B4B4B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_392_158919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvest);
export default __webpack_public_path__ + "static/media/invest.d2cd7686a4400d03e3ad3fd133becb56.svg";
export { ForwardRef as ReactComponent };